import * as React from "react"
import { connect } from "react-redux"
import trans from "trans";

import { URL } from 'app/config/api-config'

import {
    css,
    Theme,
    Select,
    Icon,
    Grid,
    GridCell,
} from "@bdfx/mergado-ui-kit"

import { ItemInterface, ReactSortable } from "react-sortablejs"

import { Option } from "@bdfx/mergado-ui-kit/lib/components/Form/Select";

import { ID } from "app/types/app-types";
import { IconAddLayer } from "app/icons";
import { CollageLayoutImageType, CollageLayoutType } from "app/types/model-types";

import {
    updateInputValue as change,
} from "app/reducers/form";

import { RandomProduct } from "shape-edit/types";
import { stringToHash } from "shape-edit/forms/helpers";
import { selectFormValues } from "app/reducers/form";
import { find, sortBy } from "lodash";

interface Props {
    selectedCollageId: ID
    selectedImageId: ID
    setSelectedImageId: Function
    setSelectedCollageId: Function
    collageLayoutsForm: CollageLayoutType[]
    randomProduct: RandomProduct
    change: typeof change
    deleteImage: Function
    newImage: Function
}

const iconSize = 18
export const MAX_ALTERNATIVE_IMAGES = 20

class CollageLayoutsImages extends React.Component<Props> {
    constructor(props) {
        super(props)
    }

    reorder = (list: ItemInterface[], sortedImages: CollageLayoutImageType[]) => {
        const { selectedCollageId } = this.props

        if (sortedImages) {
            const newOrder = list.map(i => i.id)
            const order = sortedImages.map(image => image.id)

            if (order.join(',') !== newOrder.join(',')) {
                let newSortedImages = {}
                newOrder.forEach((imageId, key) => {
                    const image = find(sortedImages, (image) => {
                        return image.id === imageId
                    })
                    newSortedImages[image.id] = {
                        ...image,
                        priority: key
                    }
                })
                this.props.change('collageLayoutsForm', `${selectedCollageId}.images`, newSortedImages)
            }
        }
    }

    getSortedImages = () => {
        const { selectedCollageId, collageLayoutsForm } = this.props

        const currentCollageLayout = selectedCollageId ? find(collageLayoutsForm, (collageLayout) => {
            return collageLayout.id === selectedCollageId
        }) : null

        return currentCollageLayout ? sortBy(currentCollageLayout.images, [(image) => {
            return new Number(image.priority)
        }]) : null
    }

    getIconByType = (type: string) => {
        switch (type) {
            case 'circle':
                return <img src={`${URL.publicPath}img/icons/clip-mask-circle.svg`} className={'icon-img'} />
            case 'ellipse':
                return <img src={`${URL.publicPath}img/icons/ellipse.svg`} className={'icon-img'} />
            case 'text':
                return <img src={`${URL.publicPath}img/icons/clip-mask-text.svg`} className={'icon-img'} />
            case 'bezier':
                return <img src={`${URL.publicPath}img/icons/clip-mask-bezier.svg`} className={'icon-img'} />
            case 'polygon':
                return <img src={`${URL.publicPath}img/icons/polygon.svg`} className={'icon-img'} />
            case 'rect':
            default:
                return <img src={`${URL.publicPath}img/icons/clip-mask-rectangle.svg`} className={'icon-img'} />
        }
    }

    render() {
        const { selectedCollageId, selectedImageId, randomProduct, collageLayoutsForm } = this.props

        const availableLevels: Option[] = [...Array(MAX_ALTERNATIVE_IMAGES).keys()].map((level) => {
            return {
                label: (level > 0 ? trans('alt_image') : trans('main_image')) + (level > 0 ? ` ${level}` : ``),
                value: `${level}`,
            }
        })

        const sortedImages = this.getSortedImages()
        const list = sortedImages ? sortedImages.map(image => { return { id: image.id, selected: image.id === selectedImageId } }) : []
        const hash = stringToHash(JSON.stringify(sortedImages))

        return (
            <StyledTable key={`table_${hash}`}>
                <StyledTr>
                    <td colSpan={4} style={{ background: Theme.blue }}>
                        <div className={'clickable'} onClick={() => this.props.newImage(selectedCollageId)}>
                            <IconAddLayer size={20} color={'#fff'} text={trans("add_layout_image")} />
                        </div>
                    </td>
                </StyledTr>

                {sortedImages &&
                    <ReactSortable list={list} setList={(list) => this.reorder(list, sortedImages)} handle=".muk-icon--arrows-v" tag="tbody">
                        {sortedImages.map((image: CollageLayoutImageType) => {
                            const mainImage = randomProduct ? (randomProduct.imageBlob ?? randomProduct.image_link) : null
                            const altImgIndex = image.level - 1
                            const alt = randomProduct?.alternative_images && randomProduct?.alternative_images[altImgIndex] ? randomProduct?.alternative_images[altImgIndex] : null
                            const altImage = alt ? (alt.imageBlob ?? alt.url) : null

                            const src = image.level === 0 ? mainImage : altImage

                            return <tr key={`row_${image.id}_${image.level}`} className={image.id === selectedImageId ? 'selected' : ''} onClick={() => this.props.setSelectedImageId(image.id)}>
                                <td style={{ textAlign: 'center' }}>
                                    <Grid cols={'1fr 1fr'}>
                                        <GridCell className={'centering'}><Icon style={{ cursor: 'move' }} type="arrows-v" text={`${image.priority || 0}`} color={Theme.blue} /></GridCell>
                                        <GridCell className={'centering'}>{this.getIconByType(image.shape)}</GridCell>
                                    </Grid>
                                </td>
                                <td style={{ textAlign: 'center' }}>
                                    <Select
                                        title={trans('assigned_image')}
                                        multiple={false}
                                        options={availableLevels}
                                        value={`${image.level}`}
                                        onChange={(e) => {
                                            this.props.change('collageLayoutsForm', `${selectedCollageId}.images.${image.id}.level`, e)
                                        }}
                                        className={'left'}
                                    />
                                </td>
                                <td>
                                    <span className={'action-button'} onClick={() => this.props.deleteImage(selectedCollageId, image.id)}>
                                        <Icon type={'trash'} color={Theme.red} size={iconSize} />
                                    </span>
                                </td>
                            </tr>
                        })
                        }
                    </ReactSortable>
                }
            </StyledTable>
        )
    }
}

const StyledTable = css('table')({
    width: '100%',
    border: '1px solid #eee',
    ' .selected': {
        background: '#009ba93d',
    },
    ".muk-form-group": {
        marginBottom: 0,
    },
    ' .centering': {
        alignSelf: 'center',
    },
    ' .icon-img': {
        width: '40px',
        height: '40px',
    }
})

const StyledTr = css('tr')({
    background: Theme.blue + ' !important',
    color: '#fff',
    ' td': {
        position: 'relative',
        padding: '10px',
        textAlign: 'center',
        fontWeight: 'bold',
        ':hover': {
            color: '#eee',
        },
    },
    path: {
        fill: '#fff',
        stroke: '#fff',
        color: '#fff',
    },
})


function mapStateToProps(state) {
    return {
        collageLayoutsForm: selectFormValues(state,'collageLayoutsForm'),
        randomProduct: state.randomProduct,
    }
}

export default connect(mapStateToProps, {
    change,
})(CollageLayoutsImages)